import React, { useState } from 'react';
import * as styles from './EditEmailModal.module.scss';
import Form, { Field, Submit } from '../../components/Form';
import LoadingIndicator from '../../components/LoadingIndicator';
import Modal, { ModalActionFooter, ModalTitle } from '../../components/Modal';

type Values = { email: string };

interface EditEmailModalProps {
  email: string;
  close: () => void;
  updateBilling: (values: Values) => Promise<unknown>;
}

const EditEmailModal = ({
  email,
  close,
  updateBilling,
}: EditEmailModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (values: Values) => {
    setIsLoading(true);

    updateBilling(values).finally(close);
  };

  return (
    <Modal>
      <ModalTitle close={close}>Change billing email</ModalTitle>
      <Form<Values> initialValues={{ email }} onSubmit={handleSubmit}>
        <div className={styles.emailWrapper}>
          <strong>New billing email address</strong>
        </div>

        <Field
          name="email"
          type="email"
          placeholder="Enter your email address"
        />

        <ModalActionFooter
          primary={
            <Submit disabled={isLoading}>
              {isLoading ? (
                <LoadingIndicator delay={0} adaptColor />
              ) : (
                'Update email'
              )}
            </Submit>
          }
        />
      </Form>
    </Modal>
  );
};

export default EditEmailModal;
